"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvailabilitiesHook = useAvailabilitiesHook;
const react_1 = require("react");
const general_1 = require("../utils/general");
function useAvailabilitiesHook(availability) {
    const [blocksByDay, setBlocksByDay] = (0, react_1.useState)(() => (0, general_1.sortAvailabilityBlocks)(availability || []));
    const set = (0, react_1.useCallback)((list) => {
        setBlocksByDay((0, general_1.sortAvailabilityBlocks)(list) || []);
    }, [setBlocksByDay]);
    const deleteBlock = (0, react_1.useCallback)((block, day) => {
        setBlocksByDay((prev) => {
            const dayBlocks = [...(prev[day] || [])];
            const targetIdx = dayBlocks.findIndex((b) => b === block || (b.startTime === block.startTime && b.endTime === block.endTime));
            if (targetIdx !== -1)
                dayBlocks.splice(targetIdx, 1);
            return { ...prev, [day]: dayBlocks };
        });
    }, []);
    const addBlock = (0, react_1.useCallback)((day) => {
        setBlocksByDay((prev) => {
            const dayBlocks = [...(prev[day] || [])];
            dayBlocks.push({ dayOfWeek: day, startTime: '', endTime: '' });
            return { ...prev, [day]: dayBlocks };
        });
    }, []);
    const updateBlock = (0, react_1.useCallback)((block, day, index) => {
        setBlocksByDay((prev) => {
            const dayBlocks = [...(prev[day] || [])];
            dayBlocks[index] = block;
            return { ...prev, [day]: dayBlocks };
        });
    }, []);
    const savable = (0, react_1.useCallback)(() => {
        const normalize = (t) => {
            if (!t)
                return null;
            const [h, m] = t.split(':');
            if (!h || !m)
                return null;
            return `${(h || '0').padStart(2, '0')}:${(m || '0').padStart(2, '0')}`;
        };
        return Object.values(blocksByDay)
            .flat()
            .map((b) => {
            const start = normalize(b.startTime);
            const end = normalize(b.endTime);
            return start && end ? { ...b, startTime: start, endTime: end } : null;
        })
            .filter(Boolean);
    }, [blocksByDay]);
    return {
        blocksByDay,
        deleteBlock,
        addBlock,
        updateBlock,
        set,
        savable,
    };
}
